<div class="container-generic d-flex flex-column justify-content-between h-100">
  <div class="d-flex flex-column gap-2">
    <!-- Tab Navigation -->
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link" [class.active]="activeTab() === 'create'"
           (click)="activeTab.set('create')">
          Crea Manualmente
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [class.active]="activeTab() === 'bgg'"
           (click)="activeTab.set('bgg')">
          Import da BGG
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [class.active]="activeTab() === 'rpg'"
           (click)="activeTab.set('rpg')">
          Import da RPGGeek
        </a>
      </li>
    </ul>

    <!-- Tab Content -->
    @if (activeTab() === 'create') {
      <app-game-create
        (gameAdded)="onGameAdded($event)">
      </app-game-create>
    } @else if (activeTab() === 'bgg') {
      <app-bgg-bulk-import
        provider="bgg"
        (importCompleted)="onImportCompleted()">
      </app-bgg-bulk-import>
    } @else if (activeTab() === 'rpg') {
      <app-bgg-bulk-import
        provider="rpg"
        (importCompleted)="onImportCompleted()">
      </app-bgg-bulk-import>
    }
  </div>
  <div class="row g-2 mt-2">
    <button class="btn btn-secondary w-100" (click)="goBack()">
      <i class="bi bi-arrow-left me-1" aria-hidden="true"></i>Indietro
    </button>
  </div>
</div>
